import React from 'react';

const Required = () => (
  <abbr title="required" aria-label="required">
    *
  </abbr>
);

export default Required;
